import { createContext } from 'react';
import useEngagementSurvey from '../hooks/useEngagementSurvey';
export const EngagementSurveyContext = createContext({});

const EngagementSurveyContextProvider = ({children }) => {
    const surveyData = useEngagementSurvey();
    
    return (
        <EngagementSurveyContext.Provider value={surveyData}  >{ children }</EngagementSurveyContext.Provider>
    )
}

export default EngagementSurveyContextProvider;